module.exports = __webpack_public_path__ + "acbdf5b15a8531252ffe75e5f13970f7.jpg";